import { useState, useEffect } from 'react';
import { studentStorage } from '../utils/localStorage';

export const useStudents = () => {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadStudents = () => {
    setLoading(true);
    try {
      const allStudents = studentStorage.getAll();
      setStudents(allStudents);
    } catch (error) {
      console.error('Error loading students:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadStudents();
  }, []);

  const addStudent = (studentData) => {
    try {
      const newStudent = studentStorage.add(studentData);
      setStudents(prev => [...prev, newStudent]);
      return newStudent;
    } catch (error) {
      console.error('Error adding student:', error);
      return null;
    }
  };

  const updateStudent = (id, updates) => {
    try {
      const updatedStudent = studentStorage.update(id, updates);
      if (updatedStudent) {
        setStudents(prev => 
          prev.map(student => 
            student.id === id ? updatedStudent : student
          )
        );
      }
      return updatedStudent;
    } catch (error) {
      console.error('Error updating student:', error);
      return null;
    }
  };

  const deleteStudent = (id) => {
    try {
      const success = studentStorage.delete(id);
      if (success) {
        setStudents(prev => prev.filter(student => student.id !== id));
      }
      return success;
    } catch (error) {
      console.error('Error deleting student:', error);
      return false;
    }
  };

  const getStudent = (id) => {
    return students.find(student => student.id === id) || null;
  };

  return {
    students,
    loading,
    addStudent,
    updateStudent,
    deleteStudent,
    getStudent,
    refreshStudents: loadStudents
  };
};